<template>
  <main class="main">
    <Breadcrumbs :breadcrumbs="breadcrumbs" />

    <ProductCatalog
      :title="taxonomy ? taxonomy.name : 'Каталог Шарунстор'"
      :items="products"
      :count="count"
      :page="page"
      @page="
        page = $event;
        getProducts();
      "
      @filter="
        selectedFilters = $event;
        page = 1;
        getProducts();
      "
      :subcategories="taxonomy ? taxonomy.children : topCategories"
    />
    <!-- <Reviews /> -->
    <Faq />
    <Social />
  </main>

  <Cookie />
</template>

<script setup lang="ts">
// import Reviews from "~/components/Section/Reviews.vue";
import Faq from "~/components/Section/Faq.vue";
import Social from "~/components/Section/Social.vue";

import { Product } from "~/api/Product.js";
import { Product as ProductEntity } from "~/dto/Product";
import ProductCatalog from "~/components/Section/Product-Catalog.vue";
import { Taxonomy } from "~/api/Taxonomy";
import { Taxonomy as TaxonomyEntity } from "~/dto/Taxonomy";
import Breadcrumbs from "~/components/Section/Breadcrumbs.vue";
import Cookie from "~/components/Section/Cookie.vue";

const title = ref("SHARUN.STORE - Каталог");
const metaDesc = ref("");
const pageUrl = useRequestURL().href;

useHead({
  title,
  meta: [
    { name: 'keywords', content: title },
    { name: 'description', content: metaDesc },
    { property: 'og:type', content: 'website' },
    { property: 'og:site_name', content: 'Шарунстор' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: metaDesc },
    { property: 'og:url', content: pageUrl },
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: metaDesc },
  ],
});

const route = useRoute();

const taxonomy = ref<TaxonomyEntity>();
const topCategories = ref<Array<TaxonomyEntity>>([]);
const products = ref<Array<ProductEntity>>([]);
const selectedFilters = ref({});
const count = ref(0);
const page = ref(1);
const breadcrumbs = ref([
  {
    title: "Главная",
    url: "/",
  },
  {
    title: "Каталог",
    url: route.params.id ? "/catalog" : null,
  },
]);

function getProducts() {
  const search = useRoute().query.s || "";
  return Product.get({
    page: page.value,
    limit: 20,
    active: 1,
    images: 1,
    filters: JSON.stringify(selectedFilters.value),
    taxonomyId: route.params.id ? [+route.params.id] : null,
    cc: 1,
    s: search,
  }).then((data) => {
    products.value = data.products;
    count.value = data.count;
  });
}

const promises = [getProducts()];
if (!route.params.id) {
  promises.push(
    Taxonomy.getTree().then((tree) => {
      topCategories.value = tree;
    })
  );
}
if (route.params.id) {
  promises.push(
    Taxonomy.getInfo(+route.params.id)
      .then((t: TaxonomyEntity) => {
        taxonomy.value = t;
        t.tree.forEach((el) =>
          breadcrumbs.value.push({
            title: el.name,
            url: `/catalog/${el.id}`,
          }),
        );
        title.value = `ШАРУНСТОР - ${t.name}`;
        metaDesc.value = t.description ?? '';

        breadcrumbs.value.push({
          title: t.name,
          url: "",
        });
      })
      .catch(() => {
        const router = useRouter();
        router.push("/catalog");
      }),
  );
}

await Promise.all(promises);
</script>
